import ForgotPasswordForm from "@Components/common/auth/forgot-password-form";
import SignInForm from "@Components/common/auth/sign-in-form";
import LoadingButton from "@Components/common/loading-button";
import ContainerWrapper from "@Components/generic/container-wrapper";
import Icon from "@Components/generic/icon";
import { AppContext, UnityBridge } from "@Context/common/general/context";
import LogoAlphaIcon from "@Resources/app/icons-v2/logo-alpha-icon";
import { faDoorOpen } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";

const pageId: any = "SIGNIN";

const SignIn = () => {
  const { i18n } = useI18n();
  const { state } = React.useContext(AppContext);
  const theme = useTheme();
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [showResetConfirmationMessage, setShowResetConfirmationMessage] = useState(false);
  const isVR = state.device.isVR && state.device.isUnityEmbedded;

  const togglePasswordReset = () => {
    setShowPasswordReset(!showPasswordReset);
  };

  const togglePasswordConfirmation = () => {
    setShowResetConfirmationMessage(!showResetConfirmationMessage);
  };

  useEffect(() => {
    state.app.events.exclusivePageEntered.emit();
    return () => {
      state.app.events.exclusivePageExited.emit();
    };
  }, []);

  const handleForgotPassword = () => {
    setTimeout(togglePasswordReset, 150);
  };

  const handleExit = () => {
    UnityBridge.dispatchWebEvent({
      type: UnityBridge.OutgoingWebEvents.ExitApplicationSignal,
      payload: {},
    });
  };

  return (
    <ContainerWrapper id={pageId} animate={false}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box sx={{ marginTop: theme.spacing(6), filter: theme.palette.mode === "dark" ? "contrast(0%) brightness(300%);" : undefined }}>
          <LogoAlphaIcon />
        </Box>
        <Box sx={{ width: "100%", marginTop: theme.spacing(4), height: "100%" }}>
          {!showPasswordReset ? (
            <>
              <Typography variant="textBase500" color="dsNeutral.v400">
                {i18n("signin.welcome")}
              </Typography>
              <SignInForm showResetConfirmationMessage={showResetConfirmationMessage} togglePasswordReset={togglePasswordReset} hideSignUp />
            </>
          ) : (
            <ForgotPasswordForm togglePasswordReset={togglePasswordReset} togglePasswordConfirmation={togglePasswordConfirmation} />
          )}
        </Box>
        <Button onClick={handleForgotPassword} sx={{ marginTop: theme.spacing(1) }} color="secondary" fullWidth>
          {!showPasswordReset ? i18n("signin.forgot.password.ingress") : i18n("back")}
        </Button>
        {isVR && (
          <Box
            sx={{
              marginTop: theme.spacing(3),
              width: theme.spacing(30),
            }}
          >
            <Button fullWidth variant="contained" color="tertiary" onClick={handleExit} startIcon={<Icon icon={faDoorOpen} />}>
              {i18n("button.exit.app")}
            </Button>
          </Box>
        )}
      </Container>
    </ContainerWrapper>
  );
};

export default SignIn;
